module.exports = __webpack_public_path__ + "static/cta-2-moc-1-8ee726a31027115d1c7c8f44f0e76e9c.png";